import { useEffect, useState } from 'react'
import Modal from './Modal'
import Boton from './Boton'
import SelectorArticulosModal from './SelectorArticulosModal'
import { clienteCodigosApi } from '../api/notasVenta'

// Sub-ABM: códigos que el cliente usa para identificar nuestros artículos.
// Cuando se carga uno, el buscador del ítem de NV (con cliente_id) lo encuentra
// tipeando ese código.
export default function ModalCodigosClienteArticulo({ cliente, onClose }) {
  const [filas, setFilas] = useState([])
  const [cargando, setCargando] = useState(true)
  const [pickArticulo, setPickArticulo] = useState(false)
  const [nuevoCodigo, setNuevoCodigo] = useState('')
  const [nuevoArticulo, setNuevoArticulo] = useState(null)
  const [guardando, setGuardando] = useState(false)
  const [error, setError] = useState('')

  const recargar = () => {
    setCargando(true)
    clienteCodigosApi.listar(cliente.id)
      .then(({ data }) => setFilas(data))
      .catch(() => {})
      .finally(() => setCargando(false))
  }

  useEffect(recargar, [cliente.id]) // eslint-disable-line react-hooks/exhaustive-deps

  const agregar = async () => {
    if (!nuevoArticulo || !nuevoCodigo.trim()) {
      setError('Elegí un artículo y escribí el código del cliente.')
      return
    }
    setGuardando(true)
    setError('')
    try {
      await clienteCodigosApi.crear(cliente.id, {
        articulo_id: nuevoArticulo.id,
        codigo: nuevoCodigo.trim(),
      })
      setNuevoCodigo('')
      setNuevoArticulo(null)
      recargar()
    } catch (e) {
      setError(e.response?.data?.errors?.codigo?.[0] || e.response?.data?.message || 'Error al guardar.')
    } finally {
      setGuardando(false)
    }
  }

  const eliminar = async (id) => {
    if (!window.confirm('¿Quitar este código?')) return
    await clienteCodigosApi.eliminar(cliente.id, id)
    recargar()
  }

  return (
    <Modal title={`SKUs del cliente — ${cliente.nombre}`} onClose={onClose} maxWidth="640px">
      <p style={{ margin: '0 0 0.75rem', fontSize: '0.85rem', color: '#475569' }}>
        Algunos clientes piden por <b>su propio código</b>. Cargá la equivalencia y el buscador del ítem de NV
        encuentra el artículo tipeando ese código (sólo para este cliente).
      </p>

      <div style={st.altaCard}>
        <div style={st.row}>
          <div style={{ flex: 2 }}>
            <label style={st.lbl}>Artículo de LGR</label>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
              <input
                style={{ ...st.inp, background: '#f8fafc', cursor: 'default' }}
                readOnly
                value={nuevoArticulo ? `${nuevoArticulo.codigo_alfa} — ${nuevoArticulo.descripcion}` : ''}
                placeholder="Elegí un artículo…"
              />
              <Boton variante="secondary" sm onClick={() => setPickArticulo(true)}>🔍</Boton>
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <label style={st.lbl}>Código del cliente</label>
            <input
              style={st.inp}
              value={nuevoCodigo}
              onChange={e => setNuevoCodigo(e.target.value)}
              placeholder="Ej: SKU-1234"
              maxLength={60}
            />
          </div>
          <Boton variante="primary" sm onClick={agregar} disabled={guardando || !nuevoArticulo || !nuevoCodigo.trim()}>
            {guardando ? '...' : '+ Agregar'}
          </Boton>
        </div>
        {error && <div style={st.err}>{error}</div>}
      </div>

      <div style={{ marginTop: '0.875rem', maxHeight: '50vh', overflow: 'auto' }}>
        {cargando ? (
          <p style={{ color: '#94a3b8' }}>Cargando…</p>
        ) : filas.length === 0 ? (
          <p style={{ color: '#94a3b8', fontSize: '0.875rem' }}>Este cliente todavía no tiene códigos cargados.</p>
        ) : (
          <table style={st.table}>
            <thead>
              <tr>
                <th style={st.th}>Código cliente</th>
                <th style={st.th}>Artículo LGR</th>
                <th style={st.th}>Descripción</th>
                <th style={st.th}></th>
              </tr>
            </thead>
            <tbody>
              {filas.map(f => (
                <tr key={f.id} style={st.tr}>
                  <td style={st.td}><code>{f.codigo}</code></td>
                  <td style={st.td}><code>{f.articulo?.codigo_alfa}</code></td>
                  <td style={st.td}>{f.articulo?.descripcion}</td>
                  <td style={{ ...st.td, textAlign: 'right' }}>
                    <Boton variante="destructive" sm onClick={() => eliminar(f.id)}>🗑</Boton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {pickArticulo && (
        <SelectorArticulosModal
          modo="simple"
          onSelect={(a) => { setNuevoArticulo(a); setPickArticulo(false) }}
          onClose={() => setPickArticulo(false)}
        />
      )}
    </Modal>
  )
}

const st = {
  altaCard: { padding: '0.75rem', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8 },
  row: { display: 'flex', gap: '0.625rem', alignItems: 'flex-end' },
  lbl: { display: 'block', fontWeight: 600, fontSize: '0.78rem', color: '#475569', marginBottom: 4 },
  inp: { width: '100%', padding: '0.42rem 0.6rem', border: '1px solid #d1d5db', borderRadius: 6, fontSize: '0.875rem', boxSizing: 'border-box' },
  err: { marginTop: 6, fontSize: '0.78rem', color: '#dc2626' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' },
  th: { padding: '0.5rem 0.75rem', textAlign: 'left', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', fontSize: '0.78rem', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em' },
  tr: { borderBottom: '1px solid #f1f5f9' },
  td: { padding: '0.5rem 0.75rem' },
}
